module.exports = __webpack_public_path__ + "img/01.1f6a2c7f.png";